import { render, staticRenderFns } from "./UserRoleDetailDialog.vue?vue&type=template&id=2cafd8ca&scoped=true"
import script from "./UserRoleDetailDialog.vue?vue&type=script&lang=js"
export * from "./UserRoleDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./UserRoleDetailDialog.vue?vue&type=style&index=0&id=2cafd8ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cafd8ca",
  null
  
)

export default component.exports